import { ReactNode } from 'react';
import styled from 'styled-components';

export const DetailContainer = styled.div<{ $inline: boolean }>`
    flex-direction: ${({ $inline }) => ($inline ? 'row' : 'column')};
    margin-bottom: 1rem;
`;

export const Value = styled.span<{ $inline: boolean }>`
    margin-top: ${({ $inline }) => ($inline ? 0 : '.5rem')};
    width: ${({ $inline }) => ($inline ? 'auto' : '100%')};
`;

export type DetailProps = Readonly<{
    /**
     * The label of the detail.
     */
    label: ReactNode;
    /**
     * The value of the detail.
     */
    children?: ReactNode;
    /**
     * If the details should be formatted inline (value beside the label),
     * or not inline (value underneath the label) (defaults to `true`).
     */
    inline?: boolean;
    /**
     * Optional classes.
     */
    className?: string;
    /**
     * Optional classes for the label.
     */
    labelClassName?: string;
}>;

export function Detail({
    label,
    inline = true,
    children,
    className,
    labelClassName,
}: DetailProps) {
    return (
        <DetailContainer
            className={`flex-row flex-wrap align-start align-baseline ${className ?? ''}`}
            $inline={inline}
        >
            <div
                className={`${inline ? 'flex-row align-center' : ''} mr-10 bold ${
                    labelClassName ?? ''
                }`}
            >
                {label}
                {inline ? ':' : ''}
            </div>
            <Value $inline={inline}>{children}</Value>
        </DetailContainer>
    );
}
